import {extendTailwindMerge} from 'tailwind-merge'

import type {ClassNameValue} from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'd1', 'd1-xs',
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'h1', 'h1-xs', 'h2', 'h2-xs', 'h3', 'h3-xs', 'h4', 'h4-xs',
            'p1', 'p1-emphasized', 'p2', 'p2-emphasized', 'p3', 'p3-emphasized',
            'size-inherit',
          ],
        },
      ],
    },
  },
})

export const logResults = (inputs: ClassNameValue) => {
  console.log('Inputs:', inputs)
  const result = twMerge(inputs)
  console.log('Outputs: ', result)
  return result
}